import * as actionTypes from "../actionTypes/Index";
import { productInitilState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...productInitilState };

export const appendUpdateProducts = (payload: any, state: any) => {
  if (payload.isPaginatedRes) {
    return [...state.products, ...payload.productData];
  }
  return payload.productData.slice();
};

export default function productReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {

    case actionTypes.CREATE_GLOBAL_PRODUCT_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isProductAdded: false,
        isProductBulkUploaded: false,
        isProductInventoryUploaded: false,
        isProductDetailsFetched: false,
        error: null,
      });
    }
    case actionTypes.CREATE_GLOBAL_PRODUCT_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isProductAdded: true,
      });
    }
    case actionTypes.CREATE_GLOBAL_PRODUCT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isProductAdded: false,
        error: action.error,
      });
    }
    case actionTypes.GET_PRODUCTS_INIT: {
      return Object.assign({}, state, {
        isFetchProductLoading: true,
        isFetchProductError: false,
        isProductAdded: false,
        isProductUpdated: false,
        isProductBulkUploaded: false,
        isProductInventoryUploaded: false,
        isProductDetailsFetched: false,
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_PRODUCTS_SUCCESS: {
      return Object.assign({}, state, {
        isFetchProductLoading: false,
        products: appendUpdateProducts(action.payload, state),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_PRODUCTS_FAIL: {
      return Object.assign({}, state, {
        isFetchProductLoading: false,
        isFetchProductError: true,
        error: action.error,
      });
    }

    case actionTypes.GET_GLOBAL_PRODUCTS_DETAILS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isProductAdded: false,
        isProductBulkUploaded: false,
        isProductInventoryUploaded: false,
        isProductDetailsFetched: false,
        productDetails: {},
      });
    }
    case actionTypes.GET_GLOBAL_PRODUCTS_DETAILS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isProductDetailsFetched: true,
        productDetails: action.payload,
      });
    }
    case actionTypes.GET_GLOBAL_PRODUCTS_DETAILS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.CLEAR_GLOBAL_PRODUCT_DETAILS: {
      return Object.assign({}, state, {
        productDetails: [],
        isProductDetailsFetched: false,
        isError: false,
        error: null,
      });
    }
    case actionTypes.BULK_UPLOAD_INIT: {
      return Object.assign({}, state, {
        isProductBulkUploading: true,
        isProductBulkUploadingError: false,
        isProductBulkUploaded: false,
        isProductDetailsFetched: false,
        error: null,
      });
    }
    case actionTypes.BULK_UPLOAD_SUCCESS: {
      return Object.assign({}, state, {
        isProductBulkUploading: false,
        isProductBulkUploaded: true,
      });
    }
    case actionTypes.BULK_UPLOAD_FAIL: {
      return Object.assign({}, state, {
        isProductBulkUploading: false,
        isProductBulkUploadingError: true,
        isProductBulkUploaded: false,
        error: action.error,
      });
    }
    case actionTypes.INVENTORY_UPLOAD_INIT: {
      return Object.assign({}, state, {
        isProductInventoryUploading: true,
        isProductInventoryUploadingError: false,
        isProductInventoryUploaded: false,
        isProductDetailsFetched: false,
        error: null,
      });
    }
    case actionTypes.INVENTORY_UPLOAD_SUCCESS: {
      return Object.assign({}, state, {
        isProductInventoryUploading: false,
        isProductInventoryUploaded: true,
      });
    }
    case actionTypes.INVENTORY_UPLOAD_FAIL: {
      return Object.assign({}, state, {
        isProductInventoryUploading: false,
        isProductInventoryUploadingError: true,
        isProductInventoryUploaded: false,
        error: action.error,
      });
    }

    case actionTypes.UPDATE_GLOBAL_PRODUCT_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isProductUpdated: false,
        error: null,
        isProductAdded: false,
        isProductBulkUploaded: false,
        isProductInventoryUploaded: false,
      });
    }
    case actionTypes.UPDATE_GLOBAL_PRODUCT_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isProductUpdated: true,
        productDetails: [],
        isProductDetailsFetched: false,
      });
    }
    case actionTypes.UPDATE_GLOBAL_PRODUCT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isProductUpdated: false,
        error: action.error,
      });
    }

    case actionTypes.GET_PRODUCT_TYPE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        productTypes: [],
      });
    }
    case actionTypes.GET_PRODUCT_TYPE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        productTypes: action.payload,
      });
    }
    case actionTypes.GET_PRODUCT_TYPE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        productTypes: [],
        isError: true,
      });
    }
    case actionTypes.GET_PRODUCT_UOM_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        productUomList: [],
      });
    }
    case actionTypes.GET_PRODUCT_UOM_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        productUomList: action.payload,
      });
    }
    case actionTypes.GET_PRODUCT_UOM_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        isError: true,
        productUomList: [],
      });
    }
    case actionTypes.GET_PRODUCT_BRANDS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        productBrands: [],
      });
    }
    case actionTypes.GET_PRODUCT_BRANDS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        productBrands: action.payload,
      });
    }
    case actionTypes.GET_PRODUCT_BRANDS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        productBrands: [],
        isError: true,
      });
    }
    case actionTypes.GET_WAREHOUSE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        wareHouseNames: [],
      });
    }
    case actionTypes.GET_WAREHOUSE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        wareHouseNames: (action.payload as any).slice(),
      });
    }
    case actionTypes.GET_WAREHOUSE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        wareHouseNames: [],
        isError: true,
      });
    }

    case actionTypes.GET_PRODUCT_INVENTORY_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        productInventory: [],
        isProductInventoryFetched: false,
      });
    }
    case actionTypes.GET_PRODUCT_INVENTORY_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        productInventory: (action.payload as any).slice(),
        isProductInventoryFetched: true,
      });
    }
    case actionTypes.GET_PRODUCT_INVENTORY_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        productInventory: [],
        isError: true,
      });
    }
    case actionTypes.UPDATE_PRODUCT_INVENTORY_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isProductInventoryUpdated: false,
      });
    }
    case actionTypes.UPDATE_PRODUCT_INVENTORY_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isProductInventoryUpdated: true,
        productInventoryDetails: [],
        isProductInventoryDetailsFetched: false,
      });
    }
    case actionTypes.UPDATE_PRODUCT_INVENTORY_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isProductInventoryUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ODOO_TAX_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        odooTax: null,
        isOdooTaxFetched: false,
        error: null,
      });
    }
    case actionTypes.GET_ODOO_TAX_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        odooTax: (action.payload as any).slice(),
        isOdooTaxFetched: true,
      });
    }
    case actionTypes.GET_ODOO_TAX_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        odooTax: null,
        isOdooTaxFetched: false,
        error: action.error,
      });
    }

    default:
      return state;
  }
}
